import { inject, Injectable } from '@angular/core';
import { EP } from '@core/config';
import { finalize, map, Observable, shareReplay } from 'rxjs';
import { HttpRequest } from './http-request';

/**
 * In-flight share for GetApplicationStatus.
 * Concurrent callers with the same userId share one HTTP request;
 * after complete/error the slot clears so the next call always hits the network.
 * Never returns stale cached status for resume/refresh.
 */
@Injectable({ providedIn: 'root' })
export class ApplicationStatusService {
  private _http = inject(HttpRequest);

  private inFlightUserId: string | number | null = null;
  private inFlight$: Observable<any> | null = null;

  fetch(userId: string | number): Observable<any> {
    if (this.inFlight$ && this.inFlightUserId === userId) {
      return this.inFlight$;
    }

    this.inFlightUserId = userId;
    this.inFlight$ = this._http
      .getParam(EP.GetApplicationStatus, { params: { userId } })
      .pipe(
        map((res: any) => {
          const list = Array.isArray(res) ? res : (res?.data ?? []);
          return list.filter((item: any) => item.isDeleted === false);
        }),
        finalize(() => {
          this.inFlightUserId = null;
          this.inFlight$ = null;
        }),
        // Keep connection until HTTP settles so a brief unsubscribe doesn't cancel peers
        shareReplay({ bufferSize: 1, refCount: false })
      );

    return this.inFlight$;
  }
}
